export function noVerifiedAccounts(error) {
    return error
}
